export default __webpack_public_path__ + "static/media/4.863109e4.png";